import { I18n as I18nInstance } from 'i18n-js'

export const I18n = new I18nInstance()
I18n.defaultLocale = window.HCM_I18N_DEFAULT_LOCALE || 'en'
I18n.locale = window.HCM_I18N_LOCALE || I18n.defaultLocale

window.I18n = I18n

export function loadI18All () {
  const translations = window.HCM_I18N_TRANSLATIONS || []

  translations.forEach((module) => {
    const data = module.default || module

    if (data && typeof data === 'object') I18n.store(data)
  })
}
